import { createSlice } from "@reduxjs/toolkit";
const initialState = { menu: "", subMenu: "" };

export const activeMenuSlice = createSlice({
    name: "activeMenu",
    initialState,
    reducers: {
        setActiveMenu: (state,action) => {
          state.menu = action.payload.menu ;
          state.subMenu = action.payload.subMenu || "summary";
        }
    }
});

export const {setActiveMenu} = activeMenuSlice.actions;
export default activeMenuSlice.reducer;
